import { render } from "./RequestDesign.vue?vue&type=template&id=24078ace"
import script from "./RequestDesign.vue?vue&type=script&lang=js"
export * from "./RequestDesign.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__